import { render, staticRenderFns } from "./event-admin-table.vue?vue&type=template&id=5376d5c1&"
import script from "./event-admin-table.vue?vue&type=script&lang=js&"
export * from "./event-admin-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports